import Container from '@/components/Container';

export const HighlightSkeleton = () => {
  return (
    <div className="ml-[calc(50%-50vw)] w-screen bg-light-green p-sh-16 md:p-sh-60">
      <Container>
        <div className="col-span-12">
          <div className="mb-sh-30 h-8 w-32 animate-pulse rounded bg-gray-300" />
          <div className="col-span-12 flex flex-col items-start">
            <div className="grid w-full grid-cols-1 gap-sh-30 md:grid-cols-[1fr_1fr]">
              <div className="highlight-image-border-loading flex aspect-video animate-pulse justify-center overflow-hidden rounded-sh-16 bg-gray-300" />
              <div className="flex flex-col gap-4">
                <div className="h-9 w-3/4 animate-pulse rounded bg-gray-300" />
                <div className="h-4 w-full animate-pulse rounded bg-gray-300" />
                <div className="h-4 w-2/3 animate-pulse rounded bg-gray-300" />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

const LessonCardSkeleton = () => {
  return (
    <div className="flex flex-col gap-sh-16 rounded-sh-16 border border-people-gray-200 bg-white p-sh-16 md:flex-row md:gap-sh-25">
      <div className=" w-full animate-pulse rounded-t-sh-16 bg-gray-300 md:w-[359px] md:rounded-sh-16" />
      <div className="flex flex-1 flex-col gap-sh-16 pt-0 md:pt-sh-16">
        <div className="h-7 w-3/4 animate-pulse rounded bg-gray-300" />
        <div className="h-4 w-20 animate-pulse rounded bg-gray-300" />
        <div className="h-4 w-full animate-pulse rounded bg-gray-300" />
        <div className="h-4 w-2/3 animate-pulse rounded bg-gray-300" />
        <div className="h-4 w-24 animate-pulse rounded bg-gray-300" />
      </div>
    </div>
  );
};

const CoursesSkeleton = () => {
  return (
    <div className="col-span-12">
      <div className="flex flex-col gap-sh-30">
        <LessonCardSkeleton />
        <LessonCardSkeleton />
        <LessonCardSkeleton />
      </div>
    </div>
  );
};

export default CoursesSkeleton;
